import React from 'react';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';
import { Row, Col, Button, Label } from 'reactstrap';
// import { Row, Col, Button, Label } from 'reactstrap';
import {
  Card,
  CardBody,
  Collapse,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { Formik, Field, Form } from 'formik';
import {
  IoIosAddCircleOutline,
  IoIosInformationCircleOutline,
} from 'react-icons/io';
import ModalConditionsContainer from '../../containers/modal/modal-conditions';
import Geocode from 'react-geocode';
import { gMapApiKey } from '../../constants/config';

//style
import { SimpleSearch, Fonts, PopoverBodyStyled, UncontrolledPopoverStyledSections } from '../../global.css';

Geocode.setApiKey(gMapApiKey());

const Checkbox = props => (
  <Field name={props.name}>
    {({ field, form }) => {
      const { value, id, name } = props;
      return (
        <input
          type="checkbox"
          {...props}
          checked={field.value && field.value.includes(value)}
          onChange={() => {
            if (field.value && field.value.includes(value)) {
              const nextValue = field.value.filter(oldVal => oldVal !== value);
              form.setFieldValue(name, nextValue);
            } else {
              const nextValue = field.value.concat(value);
              form.setFieldValue(name, nextValue);
            }
          }}
          id={id}
        />
      );
    }}
  </Field>
);

Checkbox.propTypes = {
  name: PropTypes.string,
  id: PropTypes.any,
  value: PropTypes.any,
  'display-value': PropTypes.any,
  'cond-children': PropTypes.any,
  parent: PropTypes.any,
};

class FindATrial extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedOptions: null,
      SearchTerm: '',
      collapse: false,
      formInitialized: false,
      preselectedCountry: '',
      popoverOpen: false,
      dropdownOpen: false,
      searchCountry: '',
      countries: [],
    };

    this.searchParams = null;
    this.selectedConditions = [];
    this.healthOption = '';
    this.preselectedZip = '';
    this.dropdownMenuRef = React.createRef();

    this.toggle = this.toggle.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.collapse = this.collapse.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  onKeyDown(event) {
    if (
      this.state.dropdownOpen &&
      event &&
      event.key &&
      /[a-z,A-Z]/.test(event.key)
    ) {
      let searchCountry = this.state.searchCountry;
      if (event.key.length === 1) {
        searchCountry = this.state.searchCountry + event.key;
      } else {
        if (event.which && event.which === 8 && searchCountry.length) {
          searchCountry = searchCountry.substring(0, searchCountry.length - 1);
        }
      }
      this.setState({
        searchCountry,
      });
    }
  }

  componentDidMount() {
    let { location, data } = this.props;
    if (
      typeof window !== 'undefined' &&
      window.manifest &&
      window.manifest.masterData
    ) {
      data.site.siteMetadata.masterData = window.manifest.masterData;
    }

    try {
      this.searchParams = new URL(location.href).searchParams;
    } catch (e) {
      this.searchParams = new URLSearchParams('');
    }

    if (this.searchParams.get('Conditions')) {
      this.selectedConditions = this.searchParams.get('Conditions').split('~');
    }

    let preselectedCountry = '';
    if (this.searchParams.get('country')) {
      preselectedCountry = this.searchParams.get('country');
    }

    if (this.searchParams.get('zip')) {
      this.preselectedZip = this.searchParams.get('zip');
    }

    if (this.searchParams.get('HealthyVolunteer')) {
      this.healthOption = this.searchParams.get('HealthyVolunteer');
    }

    if (this.selectedConditions && this.selectedConditions.length) {
      let selectedDisplayValues = [];
      if (Array.isArray(data.site.siteMetadata.masterData.Data.CONDITION)) {
        data.site.siteMetadata.masterData.Data.CONDITION.forEach(condition => {
          if (this.selectedConditions.includes(condition.InternalValue)) {
            selectedDisplayValues.push(condition.DisplayValue);
          }

          if (condition.Children && condition.Children.length) {
            condition.Children.forEach(condition => {
              if (this.selectedConditions.includes(condition.InternalValue)) {
                selectedDisplayValues.push(condition.DisplayValue);
              }
            });
          }
        });
      }
      this.setState({
        selectedOptions: selectedDisplayValues.join(', '),
        formInitialized: true,
        preselectedCountry,
        countries: data.site.siteMetadata.masterData.Data.COUNTRY,
      });
    } else {
      this.setState({
        formInitialized: true,
        preselectedCountry,
        countries: data.site.siteMetadata.masterData.Data.COUNTRY,
      });
    }

    document.addEventListener('keydown', this.onKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown);
  }

  toggleDropdown() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
      searchCountry: '',
    });
  }

  toggle(type) {
    this.setState({
      [type]: !this.state[type],
    });
  }

  togglePopover() {
    this.setState({
      popoverOpen: !this.state.popoverOpen,
    });
  }

  collapse() {
    this.setState(state => ({ collapse: !state.collapse }));
  }

  resetForm() {
    if (
      typeof window !== 'undefined' &&
      typeof window.location !== 'undefined'
    ) {
      window.location.reload();
    } else {
      if (this.props.location && this.props.location.reload) {
        this.props.location.reload();
      }
    }
  }

  handleSubmit(values) {
    let { location, navigate, pageContext, searchCallBack } = this.props,
      searchParams = null;
    try {
      searchParams = new URL(window ? window.location.href : location.href)
        .searchParams;
    } catch (e) {
      searchParams = new URLSearchParams('');
    }

    let finalQuery = {};
    searchParams.forEach((value, key) => {
      finalQuery[key] = value;
    });
    Object.keys(values).forEach(key => {
      finalQuery[key] = values[key];
    });

    navigate(
      `/${pageContext.langKey}/results/?${Object.keys(finalQuery)
        .map(
          k =>
            encodeURIComponent(k) +
            '=' +
            encodeURIComponent(
              Array.isArray(finalQuery[k])
                ? finalQuery[k].join('~')
                : `${finalQuery[k]}`
            )
        )
        .join('&')}`
    );
    if (searchCallBack && typeof searchCallBack === 'function') {
      setTimeout(() => {
        searchCallBack();
      });
    }
  }

  render() {
    let { data, isLight = false } = this.props;

    if (
      typeof window !== 'undefined' &&
      window.manifest &&
      window.manifest.masterData
    ) {
      data.site.siteMetadata.masterData = window.manifest.masterData;
    }

    let genders = data.site.siteMetadata.masterData.Data.GENDER.sort(
      (a, b) => a.SortOrder - b.SortOrder
    );
    let ages = data.site.siteMetadata.masterData.Data.AGERANGE.sort(
      (a, b) => a.SortOrder - b.SortOrder
    );
    let statuses = data.site.siteMetadata.masterData.Data.RECSTATUS.sort(
      (a, b) => a.SortOrder - b.SortOrder
    );

    let idSuffix = Math.floor(Math.random(400) * 1000);

    return (
      <Fonts>
        <SimpleSearch>
          {isLight ? '' : <h2>{data.homeJson.findTrial}</h2>}
          {this.state.formInitialized && (
            <Formik
              enableReinitialize={false}
              initialValues={
                isLight
                  ? {
                      SearchTerm:
                        (this.searchParams &&
                          this.searchParams.get('SearchTerm')) ||
                        '',
                      zip: this.preselectedZip,
                      country: this.state.preselectedCountry,
                    }
                  : {
                      Conditions:
                        this.selectedConditions &&
                        this.selectedConditions.length
                          ? this.selectedConditions
                          : [],
                      zip: this.preselectedZip,
                      country: this.state.preselectedCountry,
                      SearchTerm:
                        (this.searchParams &&
                          this.searchParams.get('SearchTerm')) ||
                        '',
                      Gender:
                        (this.searchParams &&
                          this.searchParams.get('Gender') &&
                          this.searchParams.get('Gender').split('~')) ||
                        [],
                      AgeRanges:
                        (this.searchParams &&
                          this.searchParams.get('AgeRanges') &&
                          this.searchParams.get('AgeRanges').split('~')) ||
                        [],
                      Status:
                        (this.searchParams &&
                          this.searchParams.get('Status') &&
                          this.searchParams.get('Status').split('~')) ||
                        [],
                    }
              }
              onSubmit={(values, actions) => {
                actions.setSubmitting(true);
                if (!isLight) {
                  values.Conditions = this.selectedConditions;
                }
                if (values.country && values.country.length) {
                  const countryName = values.country.replace('COUNTRY_', '');

                  Geocode.fromAddress(
                    countryName +
                      (values.zip && values.zip.length ? `, ${values.zip}` : '')
                  )
                    .then(
                      response => {
                        const {
                          lat,
                          lng,
                        } = response.results[0].geometry.location;
                        values.Latitude = lat;
                        values.Longitude = lng;
                        return true;
                      },
                      () => {
                        alert(
                          values.zip && values.zip.length
                            ? 'Invalid zip code and country combination'
                            : "We can't find specified address"
                        );
                        return false;
                      }
                    )
                    .then(success => {
                      actions.setSubmitting(false);
                      if (!success) {
                        return false;
                      }
                      this.handleSubmit(values);
                    });
                } else {
                  values.Latitude = '';
                  values.Longitude = '';
                  this.handleSubmit(values);
                  actions.setSubmitting(false);
                }
                setTimeout(() => {this.props.pageSearch ? this.props.pageSearch() : null}, 1000);
              }}
              render={({ isSubmitting, handleChange, setFieldValue }) => (
                <Form onReset={this.resetForm}>
                  <Row>
                    {isLight ? (
                      <Col
                        className={'general-form-input'}
                        xl={4}
                        lg={4}
                        md={12}
                      >
                        <h3>{data.trialSearchEnJson.keyword}</h3>
                        <Field
                          type="text"
                          name="SearchTerm"
                          maxLength="50"
                          placeholder={data.trialSearchEnJson.keyword}
                        />
                      </Col>
                    ) : (
                      <Col lg={4} md={12}>
                        <h3>{data.trialSearchEnJson.medicalCondition}</h3>
                        <ModalConditionsContainer
                          conditionsList={
                            data.site.siteMetadata.masterData.Data.CONDITION
                          }
                          healthVol={
                            data.site.siteMetadata.masterData.Data.HEALTHY_VOL
                          }
                          title={data.trialSearchEnJson.selectMedicalCondition}
                          buttonText={
                            typeof this.state.selectedOptions === 'string'
                              ? this.state.selectedOptions.length
                                ? this.state.selectedOptions
                                : data.trialSearchEnJson.allSelected
                              : data.trialSearchEnJson.buttonText
                          }
                          conditions={data.trialSearchEnJson.conditions}
                          all={data.trialSearchEnJson.all}
                          clear={data.trialSearchEnJson.clear}
                          accept={data.trialSearchEnJson.accept}
                          ok={data.trialSearchEnJson.ok}
                          onSelected={(list, names, healthyValue) => {
                            this.selectedConditions = list;
                            this.healthOption = healthyValue || '';
                            this.setState({
                              selectedOptions: names.join(', '),
                            });
                          }}
                          allSelected={() => {
                            this.setState({
                              selectedOptions: '',
                            });
                          }}
                        />
                      </Col>
                    )}
                    <Col className={'select-country'} lg={3} md={12}>
                      <h3>{data.trialSearchEnJson.selectCountry}</h3>
                      <Dropdown
                        isOpen={this.state.dropdownOpen}
                        toggle={this.toggleDropdown.bind(this)}
                        className={'select-dropdown'}
                      >
                        <DropdownToggle
                          className={'select-button'}
                          tag="button"
                          type="button"
                          name="country"
                          onChange={ev => {
                            handleChange(ev);
                            if (ev.target.value.length === 0)
                              setFieldValue('zip', '');
                          }}
                        >
                          {this.state.searchCountry &&
                          this.state.searchCountry.length
                            ? this.state.searchCountry
                            : this.state.preselectedCountry.length
                            ? data.site.siteMetadata.masterData.Data.COUNTRY.find(
                                country =>
                                  country.InternalValue ===
                                  this.state.preselectedCountry
                              ).DisplayValue
                            : 'All Countries'}{' '}
                          <IoIosAddCircleOutline />
                        </DropdownToggle>
                        <DropdownMenu
                          flip={false}
                          direction="down"
                          modifiers={{
                            setMaxHeight: {
                              enabled: true,
                              order: 890,
                              fn: data => {
                                return {
                                  ...data,
                                  styles: {
                                    ...data.styles,
                                    overflow: 'auto',
                                    maxHeight: 300,
                                  },
                                };
                              },
                            },
                          }}
                        >
                          {[
                            {
                              InternalValue: '',
                              DisplayValue: 'All Countries',
                            },
                          ]
                            .concat(
                              this.state.countries
                                .filter(country => {
                                  return this.state.searchCountry === ''
                                    ? true
                                    : country.DisplayValue.toLocaleLowerCase().indexOf(
                                        this.state.searchCountry.toLocaleLowerCase()
                                      ) >= 0;
                                })
                                .sort((a, b) => a.SortOrder - b.SortOrder)
                            )
                            .map(country => (
                              <DropdownItem
                                onClick={ev => {
                                  this.setState({
                                    preselectedCountry: country.InternalValue,
                                  });
                                  handleChange(ev);
                                  setFieldValue(
                                    'country',
                                    country.InternalValue
                                  );
                                  setFieldValue('zip', '');
                                }}
                                key={country.InternalValue}
                                value={country.InternalValue}
                              >
                                {country.DisplayValue}
                              </DropdownItem>
                            ))}
                        </DropdownMenu>
                      </Dropdown>
                    </Col>
                    <Col className={'general-form-input'} lg={3} md={12}>
                      {isLight === true ? (
                        <div className={'postal-code-popover'}>
                          <h3 className={'postalCode-title'}>
                            {data.trialSearchEnJson.postalCodeResults}
                          </h3>
                          <Button id="PopoverClickPostalCode" type="button">
                            <IoIosInformationCircleOutline/>
                          </Button>
                          <UncontrolledPopoverStyledSections trigger="hover"
                                                             placement={this.isMobile ? 'left' : 'top'}
                                                             target="PopoverClickPostalCode"
                          >
                                <PopoverBodyStyled dangerouslySetInnerHTML={{
                                  __html:
                                  data.trialSearchEnJson.content
                                    .childMarkdownRemark.html,
                                }}/>
                          </UncontrolledPopoverStyledSections>
                        </div>
                      ) : (
                        <h3>{data.trialSearchEnJson.postalCodeLabel}</h3>
                      )}

                      <Field
                        type="text"
                        name="zip"
                        maxLength="7"
                        disabled={this.state.preselectedCountry === ''}
                        placeholder={data.trialSearchEnJson.postalCode}
                      />
                    </Col>
                    <Col lg={2} md={12} className={'search-col'}>
                      <button
                        hidden={
                          this.state.collapse === true &&
                          window.innerWidth < 769
                        }
                        className={'search-button'}
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {data.trialSearchEnJson.search}
                      </button>
                    </Col>
                    {!isLight && (
                      <Col className={'drop-down-find'} xs={12}>
                        <button
                          className={'more-button'}
                          type="button"
                          hidden={this.state.collapse === true}
                          onClick={this.collapse}
                        >
                          {data.trialSearchEnJson.openDropDown}
                        </button>
                      </Col>
                    )}
                    {!isLight && (
                      <Col>
                        <Collapse isOpen={this.state.collapse}>
                          <Card>
                            <CardBody style={{ padding: 0 }}>
                              <Row className={'dropdown-position'}>
                                <Col>
                                  <h3>{data.trialSearchEnJson.keyword}</h3>
                                </Col>
                                <Col className={'keyword-design'} xs={12}>
                                  <Field
                                    type="text"
                                    maxLength="50"
                                    name="SearchTerm"
                                    placeholder={
                                      data.trialSearchEnJson.keywordPH
                                    }
                                  />

                                  <IoIosAddCircleOutline />
                                </Col>
                                <div className={'checkbox-filter'}>
                                  {statuses && statuses.length && (
                                    <Col
                                      className={'check-box-display'}
                                      md={4}
                                      xs={12}
                                    >
                                      <h3 className={'check-box-title'}>
                                        {data.trialSearchEnJson.trialStatus}
                                      </h3>
                                      {statuses.map((status, index) => (
                                        <Col
                                          className={'check-box-align'}
                                          key={index}
                                        >
                                          <Label
                                            htmlFor={
                                              status.InternalValue + idSuffix
                                            }
                                          >
                                            <Checkbox
                                              value={status.InternalValue}
                                              id={
                                                status.InternalValue + idSuffix
                                              }
                                              name="Status"
                                            />
                                            <span className="checkmark">
                                              <div className={'check'}>
                                                <div className={'inside'} />
                                              </div>
                                            </span>
                                            <p>{status.DisplayValue}</p>
                                          </Label>
                                        </Col>
                                      ))}
                                    </Col>
                                  )}
                                  {ages && ages.length && (
                                    <Col
                                      className={'check-box-display'}
                                      md={4}
                                      xs={12}
                                    >
                                      <h3 className={'check-box-title'}>
                                        {data.trialSearchEnJson.age}
                                      </h3>

                                      {ages.map((status, index) => (
                                        <Col
                                          className={'check-box-align'}
                                          key={index}
                                        >
                                          <Label
                                            htmlFor={
                                              status.InternalValue + idSuffix
                                            }
                                          >
                                            <Checkbox
                                              name="AgeRanges"
                                              value={status.InternalValue}
                                              id={
                                                status.InternalValue + idSuffix
                                              }
                                              display-value={
                                                status.DisplayValue
                                              }
                                            />
                                            <span className="checkmark" />
                                            <p>{status.DisplayValue}</p>
                                          </Label>
                                        </Col>
                                      ))}
                                    </Col>
                                  )}
                                  {genders && genders.length && (
                                    <Col
                                      className={'check-box-display'}
                                      md={4}
                                      xs={12}
                                    >
                                      <h3 className={'check-box-title'}>
                                        {data.trialSearchEnJson.gender}
                                      </h3>

                                      {genders.map((status, index) => (
                                        <Col
                                          className={'check-box-align'}
                                          key={index}
                                        >
                                          <Label
                                            htmlFor={
                                              status.InternalValue + idSuffix
                                            }
                                          >
                                            <Checkbox
                                              value={status.InternalValue}
                                              id={
                                                status.InternalValue + idSuffix
                                              }
                                              display-value={
                                                status.DisplayValue
                                              }
                                              name="Gender"
                                            />
                                            <span className="checkmark" />
                                            <p>{status.DisplayValue}</p>
                                          </Label>
                                        </Col>
                                      ))}
                                    </Col>
                                  )}
                                </div>
                                <Col lg={12} md={12} className={'search-col'}>
                                  <button
                                    hidden={
                                      this.state.collapse === false &&
                                      window.innerWidth > 769
                                    }
                                    className={'search-button last'}
                                    type="submit"
                                    disabled={isSubmitting}
                                  >
                                    {data.trialSearchEnJson.search}
                                  </button>
                                </Col>
                                <Col className={'drop-down-find'} xs={12}>
                                  <button
                                    className={'more-button'}
                                    type="button"
                                    hidden={this.state.collapse === false}
                                    onClick={this.collapse}
                                  >
                                    {data.trialSearchEnJson.closeDropDown}
                                  </button>
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        </Collapse>
                      </Col>
                    )}
                  </Row>
                </Form>
              )}
            />
          )}
        </SimpleSearch>
      </Fonts>
    );
  }
}

FindATrial.propTypes = {
  data: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
  pageContext: PropTypes.object.isRequired,
  location: PropTypes.object,
  isLight: PropTypes.bool,
  searchCallBack: PropTypes.func,
  pageSearch: PropTypes.func,
};

const FindATrialQuery = props => (
  <StaticQuery
    query={graphql`
      query FindATrialQuery {
        homeJson {
          findTrial
        }
        trialSearchEnJson {
          medicalCondition
          selectCountry
          openDropDown
          closeDropDown
          postalCode
          postalCodeLabel
          postalCodeResults
          search
          keyword
          keywordPH
          gender
          age
          trialStatus
          selectMedicalCondition
          conditions
          all
          clear
          accept
          yes
          no
          ok
          buttonText
          allSelected
          content {
            childMarkdownRemark {
              html
            }
          }
        }
        site {
          siteMetadata {
            masterData {
              Data {
                RECSTATUS {
                  InternalValue
                  DisplayValue
                  SortOrder
                }
                CONDITION {
                  InternalValue
                  DisplayValue
                  SortOrder
                  Children {
                    InternalValue
                    DisplayValue
                    SortOrder
                  }
                }
                COUNTRY {
                  InternalValue
                  DisplayValue
                  SortOrder
                }
                HEALTHY_VOL {
                  InternalValue
                  DisplayValue
                  SortOrder
                }
                AGERANGE {
                  InternalValue
                  DisplayValue
                  SortOrder
                }
                GENDER {
                  InternalValue
                  DisplayValue
                  SortOrder
                }
              }
            }
          }
        }
      }
    `}
    render={data => <FindATrial data={data} {...props} />}
  />
);

FindATrialQuery.propTypes = {
  children: PropTypes.node,
};

export default FindATrialQuery;
